import React from "react";
import { Box, Link, Theme, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from "react-i18next";
import { getYear } from "date-fns";

const Footer: React.FC = () => {
  const styles = useStyles();
  const { t } = useTranslation("attendanceFormlayout");

  return (
    <div className={styles.root}>
      <div className={styles.footerBackground}>
        <Box paddingBottom={2}>
          <Link href={t("privacyLinkAddress")} underline="always">
            {t("privacyLink")}
          </Link>
        </Box>
        <Typography className={styles.footer} variant="body2">
          {t("footerCopyright")}
          {getYear(new Date())}
          {t("footer")}
        </Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: theme.palette.primary.main,
    bottom: 0,
    position: "absolute",
    width: "100%",
    [theme.breakpoints.down('lg')]: {
      position: "relative",
    },
  },
  footerBackground: {
    backgroundColor: theme.palette.background.default,
    borderTop: "1px solid rgba(151, 151, 151, .25)",
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(4),
  },
  footer: {
    fontSize: 14,
    color: theme.palette.primary.main,
  },
}));

export { Footer };
